import React from 'react';
import StaticPageLayout from '../components/StaticPageLayout';

const ConflictOfInterestPage = () => (
  <StaticPageLayout
    overline="Publication Ethics"
    title="Conflict of Interest"
    description="Transparency about conflicts of interest is fundamental to the integrity of the peer review and publication process. This policy applies to all authors, reviewers, and editors."
    breadcrumbs={[{ label: 'Publication Ethics', path: '/publication-ethics' }, { label: 'Conflict of Interest', path: '/conflict-of-interest' }]}
  >
    <div className="space-y-10">
      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">What Constitutes a Conflict of Interest</h2>
        <p className="text-[#4B5563] leading-relaxed mb-4">
          A conflict of interest arises when a financial, professional, or personal relationship could compromise — or reasonably appear to compromise — the objectivity of a decision, evaluation, or report in the publication process.
        </p>
        <div className="space-y-2">
          {[
            { type: 'Financial', examples: 'Employment, consulting fees, equity ownership, honoraria, patents, or funding from organisations with a financial interest in the outcome of the research.' },
            { type: 'Professional', examples: 'Collaborative or competitive relationships with authors, shared institutional affiliation, supervisory relationships, or co-authorship on recent publications.' },
            { type: 'Personal', examples: 'Close personal relationships, family ties, or known personal animosities with any party involved in the submission being reviewed.' },
          ].map(item => (
            <div key={item.type} className="border border-[#E5E7EB] p-4 bg-white flex gap-3 text-sm">
              <span className="font-semibold text-[#374151] flex-shrink-0 w-24">{item.type}</span>
              <span className="text-[#6B7280] leading-relaxed">{item.examples}</span>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">Disclosure Requirements</h2>
        <div className="space-y-3">
          {[
            { role: 'Authors', desc: 'Must disclose all funding sources and any relationships that could be perceived as influencing the reported results or conclusions. Disclosures are published alongside the article.' },
            { role: 'Reviewers', desc: 'Must declare any potential conflicts with the manuscript under review and decline to review if a significant conflict exists. Reviewers should not use unpublished manuscripts for their own research without explicit consent.' },
            { role: 'Editors', desc: 'Must recuse themselves from editorial decisions involving manuscripts where they have a conflict of interest. An alternative editor will be assigned in such cases.' },
          ].map(item => (
            <div key={item.role} className="border border-[#E5E7EB] p-5 bg-white">
              <h3 className="font-semibold text-[#1F1F1F] text-sm mb-1.5">{item.role}</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  </StaticPageLayout>
);

export default ConflictOfInterestPage;
